import type { EntryPoint, EntryPointComponent } from 'react-relay';

import type { A2uiSurfaceAdapterRovoProps } from '@atlassian/a2ui-renderer-next/v0_9/a2ui-surface-adapter-rovo';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

/**
 * On-demand entry point for the A2UI v0.9 renderer.
 *
 * `interaction` priority: agentic UI only appears once an agent streams an
 * `AGENTIC_UI` message, so the heavy `@a2ui/*` engine chunk is fetched lazily
 * instead of shipping in the initial Rovo chat bundle. No queries — the
 * renderer's `messages`/`onAction` are supplied as runtime props at the call
 * site (see `InternalEntryPointContainer` in `A2uiSurfaceEntryPointRenderer`).
 */
export const a2uiSurfaceAdapterRovoEntryPoint: EntryPoint<
	EntryPointComponent<
		Record<string, never>,
		Record<string, never>,
		A2uiSurfaceAdapterRovoProps,
		Record<string, never>
	>,
	Record<string, never>
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_conversation-assistant-a2ui-surface-adapter-rovo" */ './A2uiSurfaceAdapterRovoEntryPointComponent'
			),
		{ moduleId: 'conversation-assistant-a2ui-surface-adapter-rovo-entrypoint' },
	),
	getPreloadProps: () => ({}),
});
